/**
 * Deadline eingeben: Datum, optional Uhrzeit, entfernbar (Roadmap F-09).
 *
 * Ein Baustein fuer alle Dialoge - Aufgabe, Projekt, Ziel, Key Result -, damit
 * sich das Setzen, Aendern und Entfernen ueberall gleich verhaelt.
 */
import { X } from 'lucide-react';

import { Input } from '@/ui/primitives/Input';
import type { DeadlineValue } from '@/ui/composites/deadlineValue';
import type { LocalDate } from '@/domain/types';

export function DeadlineField({ value, onChange, label = 'Deadline' }: {
  value: DeadlineValue;
  onChange: (next: DeadlineValue) => void;
  /** Fuer Screenreader, z. B. "Deadline des Key Results". */
  label?: string;
}) {
  return (
    <div className="flex items-center gap-2">
      {/* Breite ueber die Huelle: Input bringt w-full mit, cn fuehrt nicht zusammen. */}
      <div className="min-w-0 flex-1">
        <Input
          type="date"
          value={value.date}
          onChange={(e) => onChange({ date: e.target.value as LocalDate | '', time: e.target.value ? value.time : '' })}
          aria-label={label}
        />
      </div>
      <div className="w-28 shrink-0">
        <Input
          type="time"
          value={value.time}
          disabled={!value.date}
          onChange={(e) => onChange({ ...value, time: e.target.value })}
          aria-label={`${label}, Uhrzeit (optional)`}
          title="Uhrzeit (optional)"
        />
      </div>
      {value.date && (
        <button
          type="button"
          onClick={() => onChange({ date: '', time: '' })}
          aria-label={`${label} entfernen`}
          title="Deadline entfernen"
          className="grid size-9 shrink-0 place-items-center rounded-md text-ink-faint transition-colors hover:bg-surface-raised hover:text-ink"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
